// extracted by extract-css-chunks-webpack-plugin
module.exports = {"validation-error-message":"form-control-validation-error__validation-error-message___2rYuy","validationErrorMessage":"form-control-validation-error__validation-error-message___2rYuy"};
    if(module.hot) {
      // 1745960849017
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  